export default __webpack_public_path__ + "app/images/be49336a2f48a35bb8ad6bc556906309.png";